module.exports = __webpack_public_path__ + "img/189.bb9f812e.jpg";